import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <footer>
            <h3 style={{textAlign: 'center'}}>Hope you have a good time</h3>
            <p style={{textAlign: 'center', fontSize: '12px'}}>By Kieu Oanh</p>
        </footer>
    )
}

export default Footer
